import {Observable} from 'rxjs';
import {useCallback, useState} from 'react';

interface UseDisableFormSubmitResult<T> {
  isSubmit: boolean;
  onHandlerSubmit: (value: T) => void;
}

function useDisableSubmitForm<T>(
  handler: (value: T) => Observable<T>,
  close: () => void,
): UseDisableFormSubmitResult<T> {
  const [isSubmit, setIsSubmit] = useState(false);
  const onHandlerSubmit = useCallback(
    (value: T) => {
      setIsSubmit(true);
      handler(value).subscribe({
        next() {
          setIsSubmit(false);
          close();
        },
        error() {
          setIsSubmit(false);
        },
      });
    },
    [handler, close],
  );

  return {isSubmit, onHandlerSubmit};
}

export default useDisableSubmitForm;
